import { BaseApiRouteService } from "mrb/core";

class ArtistUploadApiRouteService extends BaseApiRouteService {
    constructor() {
        super("producers");
    }

    createUploadSession(producerId) {
        return `${this.base}/${producerId}/upload-session`;
    }

    completeUploadSession(producerId, sessionId) {
        return `${this.base}/${producerId}/upload-session/${sessionId}/complete`;
    }

    getLatestUploadSession(producerId) {
        return `${this.base}/${producerId}/upload-session/latest`;
    }
}

export default ArtistUploadApiRouteService;
